import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import PersonIcon from '@material-ui/icons/PersonOutline';

import classes from '../../css/getCSS';

const personalInfo = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('personalinfo')}>Edit</Button>
    );
  }

  let extraFields = null;
  if (props.profile.personalinfo.marital_status.value === 5
      || props.profile.personalinfo.marital_status.value === 6) {
    extraFields = (
      <React.Fragment>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Year of Divorced/Widowed</p>
          <p className={classes.profileVal}>{props.profile.personalinfo.marriage_end_year}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>No. of years of marriage</p>
          <p className={classes.profileVal}>{props.profile.personalinfo.marriage_years_count}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Any children</p>
          <p className={classes.profileVal}>{props.profile.personalinfo.children}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Legal Information</p>
          <p className={classes.profileVal}>{props.profile.personalinfo.legal}</p>
          <br />
        </Grid>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <PersonIcon className={classes.titleIcon} />
          Personal Info
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Birth Date</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.birth_date}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Birth Time</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.birth_time}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Birth Place</p>
            <p className={classes.profileVal}>
              {props.profile.personalinfo.birth_place
                ? props.profile.personalinfo.birth_place : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Height</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.height}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Weight</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.weight} kgs</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>&nbsp;</Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Caste</p>
            <p className={classes.profileVal}>
              {props.profile.personalinfo.caste
                ? props.profile.personalinfo.caste.label : '-'}
            </p><br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Marital Status</p>
            <p className={classes.profileVal}>
              {props.profile.personalinfo.marital_status
                ? props.profile.personalinfo.marital_status.label : '-'}
            </p>
            <br />
          </Grid>
          {extraFields}
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>About me</p>
            <p className={classes.profileVal}>{props.profile.personalinfo.about}</p>
            <br />
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default personalInfo;



// WEBPACK FOOTER //
// ./src/profile/components/PersonalInfo.js